import { FC, SyntheticEvent } from 'react';
import { CheckboxConfigType } from 'models/husqiotbus';
import Card from 'components/UI/Card';
import { SelectListItem } from './styled';
import Checkbox from 'components/UI/Checkbox';
import AccordionHeaderItem from 'components/UI/Accordion/AccordionHeaderItem';

type Props = {
  checkboxTypes: CheckboxConfigType[];
  headingId: string;
  onChange: (value: SyntheticEvent) => void;
};

const CheckboxCard: FC<Props> = ({ checkboxTypes, headingId, onChange }) => {
  return (
    <Card>
      <AccordionHeaderItem key={headingId} titleId={headingId}>
        {checkboxTypes.map((cbType) => (
          <SelectListItem key={cbType.name}>
            <Checkbox
              id={cbType.name}
              value={cbType.name}
              disabled={cbType.disabled}
              defaultChecked={cbType.checked}
              onChange={onChange}
            />
            <label htmlFor={cbType.name}>{cbType.name}</label>
          </SelectListItem>
        ))}
      </AccordionHeaderItem>
    </Card>
  );
};

export default CheckboxCard;
